export default __webpack_public_path__ + "static/form-thank-you-smiley-15be301f5ae603b82754b2220f41412a.png";